import AV from 'leancloud-storage'
class Token extends AV.Object {


          get license() {
                    return this.get('license')
          }
          set license(value) {
                    this.set('license', value)
          }

       
          get intro() {
                    return this.get('intro')
          }
          set intro(value) {
                    this.set('intro', value)
          }

   



}

AV.Object.register(Token, 'WXToken')
export default Token
